import { useState } from 'react';
import Sheet from './Sheet';
import Icon from './Icon';
import { PRIMARY } from './CaptureSheets';
import { useApp } from '../lib/AppContext';

// "This uses N AI credits" before actions that spend credits without their own form (re-analysing a meal,
// asking for another dish). "Không hỏi lại" skips it on this device for that action; unlimited accounts
// never see it. Without credits left it opens the out-of-credits sheet instead, which runs the action after
// an ad gives a credit.
const skipKey = (kind) => `macro-mate:ai-confirm-skip:${kind}`;
const skipped = (kind) => {
  try {
    return window.localStorage.getItem(skipKey(kind)) === '1';
  } catch {
    return false;
  }
};
const remember = (kind) => {
  try {
    window.localStorage.setItem(skipKey(kind), '1');
  } catch {
    // Private browsing: just ask again next time.
  }
};

// Returns [confirm, sheet]: call confirm(run) instead of run(), and render `sheet`.
export function useAiConfirm(kind, { title, cost = 1 } = {}) {
  const { membership, openPaywall } = useApp();
  const [pending, setPending] = useState(null);
  const [dontAsk, setDontAsk] = useState(false);
  const unlimited = membership && membership.credits.left == null;

  const confirm = (run) => {
    if (!membership || unlimited) return run();
    if (membership.credits.left < cost) {
      openPaywall('credits', { retry: run });
      return undefined;
    }
    if (skipped(kind)) return run();
    setDontAsk(false);
    setPending(() => run);
    return undefined;
  };
  const go = () => {
    if (dontAsk) remember(kind);
    const run = pending;
    setPending(null);
    run();
  };

  const left = membership?.credits.left;
  const sheet = (
    <Sheet open={!!pending} onClose={() => setPending(null)} title={title}>
      {pending && (
        <div className="flex flex-col gap-4">
          <div className="flex items-start gap-3 rounded-[16px] bg-[#e3f1e9] p-4 text-[#17201b]">
            <Icon name="sparkles" className="mt-0.5 size-5 shrink-0 text-[#17804f]" />
            <p className="text-sm">
              Thao tác này dùng <b>{cost} lượt AI</b>. Hôm nay bạn còn <b>{left}</b> lượt
              {membership?.month ? <> · tháng này còn <b>{membership.month.left}</b></> : null}.
              Lượt chỉ bị trừ khi AI trả kết quả thành công.
            </p>
          </div>
          <label className="flex min-h-11 cursor-pointer items-center gap-3 text-sm">
            <input type="checkbox" className="checkbox checkbox-primary size-5 rounded-[6px]" checked={dontAsk}
              onChange={(e) => setDontAsk(e.target.checked)} />
            Không hỏi lại
          </label>
          <button type="button" className={PRIMARY} onClick={go}>Tiếp tục</button>
          <button type="button" className="btn btn-ghost h-11 rounded-2xl" onClick={() => setPending(null)}>Hủy</button>
        </div>
      )}
    </Sheet>
  );
  return [confirm, sheet];
}
